<template>
  <el-card shadow="hover">
    <div slot="header" class="clearfix">
      <el-col :span="24">
        <b>Situação dos objetos</b>
      </el-col>
    </div>
    <el-table
      :show-header="false"
      :data="tableLate"
      style="width: 100%">
      <el-table-column
        prop="label"
        label="Date"
        width="180">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="Name">
        <template slot-scope="scope">
          <el-progress :color="scope.row.color" :stroke-width="13" :percentage="scope.row.quantity" :format="format"></el-progress>
          </template>
      </el-table-column>
    </el-table>
  </el-card>

</template>

<script>

import { RequestInfoService } from "@/services/customers/request.info.services";
import { UserService } from "@/services/users/user.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "RequestInfoStatusTag",
  props: ["startedAt", "finishedAt", "customer"],
  created() {
    this.$bus.$on("fetch", this.fetch);
  },
  data() {
    return {
      tableLate: [{
        color: '#5cb87a',
        label: "Entregue no prazo",
        quantity: 80,
      }, {
        color: '#f56c6c',
        label: "Entregue em atraso",
        quantity: 40,
      }, {
        color: '#1989fa',
        label: "Está em atraso",
        quantity: 12,
      }],
    };
  },
  methods: {
    fetch() {
      setTimeout(() => {
        const vm = this;
        const loading = vm.$loading(vm.$options.loading);
        console.log('vm.startedAt', vm.startedAt, vm.finishedAt)
        const s = moment(vm.startedAt);
        const f = moment(vm.finishedAt);

        console.log('vm.startedAt', s, f)
        RequestInfoService.statustag({
          customer: vm.customer,
          startedAt: s.format("YYYY-MM-DD"),
          finishedAt: f.format("YYYY-MM-DD"),

        })
          .then((response) => {
            console.log('response', response)
            vm.tableList = response;
            vm.total = response.total;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
        }, 300);
    }
  },
  mounted() {
    console.log('vm.startedAt', this.startedAt, this.finishedAt)
    this.fetch();
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
</style>